module.exports = __webpack_public_path__ + "media/images/icons/media-step-forward-e34271955684439e701a295427a9a3aa.svg";